export var getIds = function getIds(id) {
  return id ? {
    root: id,
    calendarContainer: "".concat(id, "__calendar-container"),
    monthPicker: "".concat(id, "__month-picker"),
    daysContainer: "".concat(id, "__days-container"),
    weekDay: function weekDay(index) {
      return "".concat(id, "__week-day__").concat(index);
    },
    monthDay: function monthDay(index) {
      return "".concat(id, "__month-day__").concat(index);
    },
    presetContainer: "".concat(id, "__preset-container")
  } : undefined;
};
//# sourceMappingURL=getIds.js.map